"use strict";

var _regeneratorRuntime = require("/app/front/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/app/front/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Serialization_1 = require("../../Serialization");

var Schema_1 = __importDefault(require("./Schema"));

var RpcTemplate = /*#__PURE__*/function () {
  function RpcTemplate(api, collection, id, data, schema) {
    var _this = this;

    var cache = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

    _classCallCheck(this, RpcTemplate);

    this.api = api;
    this.collection = collection;
    this.id = id;
    this._data = new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!data) {
                  _context.next = 4;
                  break;
                }

                resolve(data);
                _context.next = 15;
                break;

              case 4:
                _context.prev = 4;
                _context.t0 = resolve;
                _context.next = 8;
                return api.queue.fetchTemplate(collection, id, cache);

              case 8:
                _context.t1 = _context.sent;
                (0, _context.t0)(_context.t1);
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t2 = _context["catch"](4);
                reject(_context.t2);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 12]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    this._schema = new Promise( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
        var row;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!schema) {
                  _context2.next = 4;
                  break;
                }

                resolve(schema);
                _context2.next = 14;
                break;

              case 4:
                _context2.prev = 4;
                _context2.next = 7;
                return _this._data;

              case 7:
                row = _context2.sent;
                resolve(new Schema_1.default(_this.api, collection, row.schema_name, undefined, cache));
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](4);
                reject(_context2.t0);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 11]]);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }());
  }

  _createClass(RpcTemplate, [{
    key: "schema",
    value: function () {
      var _schema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._schema;

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function schema() {
        return _schema.apply(this, arguments);
      }

      return schema;
    }()
  }, {
    key: "immutableData",
    value: function () {
      var _immutableData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var schema;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._schema;

              case 2:
                schema = _context4.sent;
                _context4.t0 = Serialization_1;
                _context4.next = 6;
                return this._data;

              case 6:
                _context4.t1 = _context4.sent.immutable_serialized_data;
                _context4.next = 9;
                return schema.format();

              case 9:
                _context4.t2 = _context4.sent;
                return _context4.abrupt("return", _context4.t0.deserialize.call(_context4.t0, _context4.t1, _context4.t2));

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function immutableData() {
        return _immutableData.apply(this, arguments);
      }

      return immutableData;
    }()
  }, {
    key: "isTransferable",
    value: function () {
      var _isTransferable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._data;

              case 2:
                return _context5.abrupt("return", _context5.sent.transferable);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function isTransferable() {
        return _isTransferable.apply(this, arguments);
      }

      return isTransferable;
    }()
  }, {
    key: "isBurnable",
    value: function () {
      var _isBurnable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._data;

              case 2:
                return _context6.abrupt("return", _context6.sent.burnable);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function isBurnable() {
        return _isBurnable.apply(this, arguments);
      }

      return isBurnable;
    }()
  }, {
    key: "maxSupply",
    value: function () {
      var _maxSupply = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._data;

              case 2:
                return _context7.abrupt("return", _context7.sent.max_supply);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function maxSupply() {
        return _maxSupply.apply(this, arguments);
      }

      return maxSupply;
    }()
  }, {
    key: "circulation",
    value: function () {
      var _circulation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._data;

              case 2:
                return _context8.abrupt("return", _context8.sent.issued_supply);

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function circulation() {
        return _circulation.apply(this, arguments);
      }

      return circulation;
    }()
  }, {
    key: "toObject",
    value: function () {
      var _toObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.t0 = this.collection;
                _context9.t1 = this.id;
                _context9.next = 4;
                return this.schema();

              case 4:
                _context9.next = 6;
                return _context9.sent.toObject();

              case 6:
                _context9.t2 = _context9.sent;
                _context9.next = 9;
                return this.immutableData();

              case 9:
                _context9.t3 = _context9.sent;
                _context9.next = 12;
                return this.isTransferable();

              case 12:
                _context9.t4 = _context9.sent;
                _context9.next = 15;
                return this.isBurnable();

              case 15:
                _context9.t5 = _context9.sent;
                _context9.next = 18;
                return this.maxSupply();

              case 18:
                _context9.t6 = _context9.sent;
                _context9.next = 21;
                return this.circulation();

              case 21:
                _context9.t7 = _context9.sent;
                return _context9.abrupt("return", {
                  collection_name: _context9.t0,
                  template_id: _context9.t1,
                  schema: _context9.t2,
                  immutableData: _context9.t3,
                  transferable: _context9.t4,
                  burnable: _context9.t5,
                  maxSupply: _context9.t6,
                  circulation: _context9.t7
                });

              case 23:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function toObject() {
        return _toObject.apply(this, arguments);
      }

      return toObject;
    }()
  }]);

  return RpcTemplate;
}();

exports.default = RpcTemplate;